import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "proxireduc28_cookie_consent_v1";

export function useCookieConsent() {
  const [consent, setConsent] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
  });
  return { consent };
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const save = (choice) => {
    const data = { choice, at: new Date().toISOString(), version: 1 };
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch {}
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-20 inset-x-4 md:left-auto md:right-6 md:bottom-20 lg:bottom-6 md:max-w-md z-[60]"
         data-testid="cookie-banner">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-2xl p-4 md:p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-orange-50 text-[#E05638] grid place-items-center shrink-0"><Cookie size={18}/></div>
          <div className="min-w-0 flex-1">
            <div className="font-heading font-bold text-slate-900">Cookies & confidentialité</div>
            <p className="text-xs text-slate-600 mt-1 leading-relaxed">
              PROXIreduc-28 utilise uniquement des cookies techniques nécessaires à l'authentification.
              Aucun cookie publicitaire n'est déposé.{" "}
              <Link to="/cookies" className="text-[#E05638] underline">En savoir plus</Link>.
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <button onClick={()=>save("accepted")} data-testid="cookie-accept"
                      className="btn-shine text-white text-xs font-semibold px-4 py-2 rounded-lg">
                J'ai compris
              </button>
              <button onClick={()=>save("refused")} data-testid="cookie-refuse"
                      className="text-xs font-semibold px-4 py-2 rounded-lg border border-slate-200 hover:bg-slate-50">
                Continuer sans accepter
              </button>
            </div>
          </div>
          <button onClick={()=>save("refused")} className="p-1 rounded hover:bg-slate-100 text-slate-400" aria-label="Fermer"><X size={14}/></button>
        </div>
      </div>
    </div>
  );
}
